import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpressionFunctionType } from '@iotv/iotv-v3-types';
import { Stack, Switch, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
// Devices can be filtered by devices to replace (low battery/offline)
export const TypeByError = (props) => {
    const { updateParams: setParamsInParent, keyPress, attKey, index, children, selected } = props;
    const [hasError, setHasError] = useState(true);
    const handleSwitch = () => {
        setHasError(!hasError);
    };
    useEffect(() => {
        const exist = hasError ? ExpressionFunctionType.EXISTS : ExpressionFunctionType.NOT_EXISTS;
        if (selected) {
            setParamsInParent([{ key: attKey, value: undefined, predicate: exist }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [hasError, selected]);
    return (_jsxs(Toolbar, { children: [children, _jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: 'center' }, children: [_jsx(Typography, { children: "False" }), _jsx(Switch, { size: "small", checked: hasError, onChange: handleSwitch, onKeyDown: keyPress }), _jsx(Typography, { children: "True" })] })] }));
};
